module.exports = __webpack_public_path__ + "static/media/CoursePhoto.8719504f.svg";